import classNames from 'classnames';
import { t } from 'ttag';

// styles
import s from './ComplaintHeader.sss';

// types
type ComplaintHeaderProps = {
  className?: string;
};

export const ComplaintHeader: React.FC<ComplaintHeaderProps> = ({
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <p className={s.headline}>{t`З чим пов'язане ваше звернення?`}</p>
  </div>
);

export default ComplaintHeader;
